export function isNodejs() {
    return typeof global === 'object'
        && typeof require === 'function'
        && typeof module !== 'undefined'
        // issues with gatsby.js: module.exports is undefined
        // && !!module.exports
        && typeof process !== 'undefined' && !!process.version;
}
//# sourceMappingURL=isNodejs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/env/isNodejs.js
// module id = 4089
// module chunks = 0